import { addMinutes, addMonths, getDate, setDate, subDays } from 'date-fns';
import { isLastDayOfTheMonth } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/isLastDayOfTheMonth';
import { lastDayOfMonth } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/lastDayOfMonth';
import { ALL_DAY_MEAL_CREDIT_DURATION } from 'src/models/LineOfCreditModelUtils';

export interface GetCurrentMonthlyCycleEndDateProps {
  firstInstanceStartDate: Date;
  currentMonthlyCycleStartDate: Date;
  durationMinutes?: number;
  refreshPeriodMonthsCount?: number;
}
export const getCurrentMonthlyCycleEndDate = ({
  firstInstanceStartDate,
  currentMonthlyCycleStartDate,
  durationMinutes = ALL_DAY_MEAL_CREDIT_DURATION,
  refreshPeriodMonthsCount = 1,
}: GetCurrentMonthlyCycleEndDateProps): Date => {
  const firstInstanceDay = getDate(firstInstanceStartDate);
  const currentCycleDay = getDate(currentMonthlyCycleStartDate);
  const nextCycleDate = addMonths(
    currentMonthlyCycleStartDate,
    refreshPeriodMonthsCount
  );
  const finalAddition = addMinutes(nextCycleDate, durationMinutes);

  if (
    isLastDayOfTheMonth(firstInstanceStartDate) &&
    firstInstanceDay > currentCycleDay
  ) {
    return subDays(
      addMinutes(lastDayOfMonth(nextCycleDate), durationMinutes),
      1
    );
  }

  // Applies when the day from the first instance is after the current cycle day
  if (firstInstanceDay > currentCycleDay) {
    return subDays(setDate(finalAddition, firstInstanceDay), 1);
  }

  // Default case
  return subDays(finalAddition, 1);
};
